export default class ShowUserPhone {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.numberEl = document.querySelector(".userData__itemNumber");
    this.showBtn = document.querySelector(".userData__itemShow");

    if (!this.numberEl || !this.showBtn) return false;

    return true;
  }

  setupEvents() {
    this.showBtn.addEventListener("click", () => this.show());
  }

  show() {
    const n = this.numberEl.getAttribute("data-n");
    const k = this.numberEl.getAttribute("data-k");
    const i = this.numberEl.getAttribute("data-i");
    this.numberEl.innerHTML = `${n}${k}${i}`;
    this.showBtn.remove();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Components/ShowUserPhone.js